import { useMemo } from 'react';
import { generateUuid } from './playerUtils';

export const useUniqueArray = (arrayLength: number) => useMemo(() => Array.from(Array(arrayLength).keys()).map(generateUuid), [arrayLength]);
